// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_CriarOrcamentoPDFInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos/criarOrcamentoPDF
 *
 * Validates PDF generation request from HTML content.
 */
import { registerContract } from './validate'

export interface Orcamentos_CriarOrcamentoPDFInput {
HTML: string
owner_id: number
}

registerContract('Orcamentos_CriarOrcamentoPDFInput', {
  HTML:     { type: 'string',  required: true },
  owner_id: { type: 'number',  required: true },
})
